export const buscar = (url, cuerpo) => {
    return new Promise(function (resolve, reject) {
        // eslint-disable-next-line no-undef
         Citrus.AJAX.getJSON(url, cuerpo, function (respuesta) {
            // eslint-disable-next-line no-undef
            var datos = $.parseJSON(respuesta.d);
            if (
                datos &&
                datos["Mensaje"] !== undefined &&
                datos["Detalle"] !== undefined &&
                datos["Interno"] !== undefined
            ) {
                reject(datos);
            }
            resolve(datos);
        });
    });
};